import { Paragraph } from '@tiptap/extension-paragraph';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    indent: {
      increaseIndent: () => ReturnType;
      decreaseIndent: () => ReturnType;
    };
  }
}

export const IndentParagraph = Paragraph.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      indent: {
        default: 0,
        parseHTML: (element) => {
          const indent = element.getAttribute('data-indent');
          return indent ? parseInt(indent, 10) : 0;
        },
        renderHTML: (attributes) => {
          if (!attributes.indent || attributes.indent === 0) {
            return {};
          }
          return {
            'data-indent': attributes.indent,
            style: `margin-left: ${attributes.indent * 18}px`,
          };
        },
      },
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      increaseIndent:
        () =>
        ({ commands, state }) => {
          const { from, to } = state.selection;
          let updated = false;

          state.doc.nodesBetween(from, to, (node) => {
            if (node.type.name === 'paragraph') {
              const currentIndent = node.attrs.indent || 0;
              const maxIndent = 5;
              if (currentIndent < maxIndent) {
                commands.updateAttributes('paragraph', {
                  indent: currentIndent + 1,
                });
                updated = true;
              }
            }
          });

          return updated;
        },

      decreaseIndent:
        () =>
        ({ commands, state }) => {
          const { from, to } = state.selection;
          let updated = false;

          state.doc.nodesBetween(from, to, (node) => {
            if (node.type.name === 'paragraph') {
              const currentIndent = node.attrs.indent || 0;
              if (currentIndent > 0) {
                commands.updateAttributes('paragraph', {
                  indent: currentIndent - 1,
                });
                updated = true;
              }
            }
          });
          return updated;
        },
    };
  },
});
